var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microsoft"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "yeloow",
    x: 9.75,
    y: 9.75,
    width: 7.5,
    height: 7.5,
    fill: "#4F9CF9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "blue",
    x: 0.75,
    y: 9.75,
    width: 7.5,
    height: 7.5,
    fill: "#4F9CF9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "green",
    x: 9.75,
    y: 0.75,
    width: 7.5,
    height: 7.5,
    fill: "#4F9CF9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "red",
    x: 0.75,
    y: 0.75,
    width: 7.5,
    height: 7.5,
    fill: "#4F9CF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.3e11de02822f64183f4a02e823b7a363.svg";
export { ForwardRef as ReactComponent };